import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M2 12.018c0-1.812.453-3.49 1.35-5.027A10 10 0 0 1 7 3.341C8.536 2.444 10.206 2 12.009 2c1.35 0 2.646.266 3.88.79a10.1 10.1 0 0 1 3.19 2.132q1.345 1.332 2.13 3.197A9.9 9.9 0 0 1 22 12.018c0 1.35-.266 2.646-.79 3.88a10 10 0 0 1-2.132 3.189c-.888.888-1.954 1.599-3.188 2.123a9.8 9.8 0 0 1-3.881.79 9.9 9.9 0 0 1-3.899-.79 10.1 10.1 0 0 1-3.197-2.132c-.897-.888-1.599-1.954-2.131-3.18C2.249 14.674 2 13.378 2 12.019m2.202 0q-.002 3.157 2.3 5.488c1.537 1.537 3.367 2.3 5.507 2.3a7.55 7.55 0 0 0 3.899-1.048 7.9 7.9 0 0 0 2.85-2.841 7.6 7.6 0 0 0 1.057-3.9 7.6 7.6 0 0 0-1.057-3.907 7.84 7.84 0 0 0-2.85-2.85 7.57 7.57 0 0 0-3.9-1.049A7.55 7.55 0 0 0 8.11 5.26 8 8 0 0 0 5.25 8.11c-.71 1.2-1.048 2.505-1.048 3.908m7.034 0V6.103c0-.204.071-.382.213-.524a.72.72 0 0 1 .524-.213q.31 0 .524.213c.142.142.213.32.213.524v4.627l2.47-1.394a.7.7 0 0 1 .559-.08.7.7 0 0 1 .444.364.7.7 0 0 1 .071.56.72.72 0 0 1-.346.452l-3.446 1.928a.72.72 0 0 1-.498.195.72.72 0 0 1-.728-.737"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }